import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import {NavComponent} from '@Common/home/navbar/dynamic-core-components/component-interface.component';
import {BehaviorSubject} from 'rxjs';

import { Router} from '@angular/router';

import {SubSink} from '@Common/core/utils/subsink';
import { MatDialog } from '@angular/material/dialog';

import {FeedbackContainerComponent} from './feedback/feedback-container/feedback-container.component';
import {Individu, IndividuService} from '@Common/core/services';

@Component({
  templateUrl: './feedback-nav-component.html',
  styles: []
})
export class FeedBackNavComponent implements NavComponent, OnInit, OnDestroy {
  @Input() data: any;

  subSink = new SubSink();

  subject: BehaviorSubject<any> = new BehaviorSubject(null);

  connecte: Individu = null;

  constructor(private router: Router,
              private individuSvc: IndividuService,
              private dialog: MatDialog) {
  }

  onChange(event) {
    this.subject.next(event);
  }

  ngOnInit() {
    this.subSink.sink = this.individuSvc.individu$.subscribe((_ind) => {
      this.connecte = _ind;
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  openFeedback() {
    const modal = this.dialog.open(FeedbackContainerComponent);
    modal.updatePosition({top: '50px'});
  }
}
